// 按页面划分
export default {
    // 公共页面
    common: {
        title: "Trung tâm dữ liệu",
        pull_refresh: 'Kéo xuống để làm mới',
        release_refresh: 'Phát hành để làm mới',
        refresh_loading: 'Đang tải...',
        footer_text: 'Dịch vụ được cung cấp bởi Ucloudlink (NASDAQ: UCL)'
    },
    home: {
        input_placeholder: 'Tìm kiếm quốc gia/khu vực',
        my_flow: 'Dữ liệu của tôi',
        charge_code: 'Mã phiếu thưởng',
        coupons: 'Phiếu giảm giá',
        local_package: 'Dữ liệu cục bộ',
        more: 'Hơn',
        popular_destination: 'Quốc gia/khu vực',
        buy_now: 'Mua ngay',
        package_useing: 'Kích hoạt',
        unused: 'Không kích hoạt',
        download_app: 'Tải xuống Ứng dụng',
        enter_the_mall_list: 'Vào Trung tâm mua sắm',
        no_data: 'Không có dữ liệu',
        no_data_available: "Không có dữ liệu có sẵn",
        copy_success: 'Sao chép thành công',
        copy_fail: 'Sao chép không thành công',
        meritsTitle: 'Lợi ích là gì?',
        merits1: 'Không cần SIM & Không có phí hàng tháng',
        merits2: 'Tích hợp với 2-3 nhà vận hành hàng đầu để tự động chuyển mạng',
        go_buy: 'Đi mua sắm',
        instant_savings: 'Tiết kiệm',
        expires_in: 'Hết hạn trong',
        download_app_tips: "Tải app để nhận nhiều ưu đãi và trải nghiệm hơn"
    },

    packages: {
        sub_title: {
            us: 'Ngoại trừ Guam, Saipan',
            it: 'Bao gồm Thành phố Vatican, San Marino',
            va: 'Bao gồm Ý, San Marino',
            sm: 'Bao gồm Ý, Thành phố Vatican',
            ma: 'Bao gồm Tây Sahara',
            eh: 'Bao gồm Maroc',
            ch: 'Bao gồm Liechtenstein',
            li: 'Bao gồm Thụy Sĩ',
            fr: 'Bao gồm cả Monaco',
            mc: 'Trong đó có Pháp',
            fi: 'Bao gồm Quần đảo Aland',
            ax: 'Bao gồm Phần Lan',
            gu: 'Bao gồm Quần đảo Bắc Mariana',
            mp: 'Bao gồm cả đảo Guam'
        },
        unlimited_packages: 'Gói dữ liệu không giới hạn',
        normal_packages: 'Gói dữ liệu thông thường',
        multi_region_packages: 'Đa vùng',
        regional_data: 'Dữ liệu Khu vực',
        high_speed_text: 'dữ liệu tốc độ cao',
        infiniteFlow: 'Dữ liệu không giới hạn',
        unLimitData: 'Vô hạn',
        high_speed_text_year: 'tốc độ cao/mp',
        package_list: 'Danh sách gói',
        special_offer: 'Giảm giá',
        first_month: 'Tháng Đầu',
        periodUnit: {
            day: '(các) ngày',
            month: 'tháng',
            hour: 'giờ)',
            year: 'năm'
        },
        periodUnits: {
            day: '(các) ngày',
            month: 'tháng',
            hour: 'giờ)',
            year: 'năm'
        },
        periodUnitSimp: {
            day: 'd',
            month: 'vì',
            hour: 'h',
            year: 'cái'
        },
        periodUnitMonthly:'Hàng tháng',
        periodUnitsSimp: {
            day: 'd',
            month: 'vì',
            hour: 'h',
            year: 'cái'
        },
        unlimited_good_name: {
            day: 'Vé ngày',
            month: 'Vé tháng',
            year: 'Thẻ hàng năm'
        },
        continuousMonth: "Những tháng liên tục",
        continuousDay: "Ngày liên tục",
        continuousYear: "Năm liên tục",

        day_invalid: 'Hết hạn vào ngày hiện tại',
        month_invalid: 'Hết hạn vào tháng hiện tại',
        immediate_valid: 'Có hiệu lực ngay lập tức',
        tomorrow_day_valid: 'Có hiệu lực từ ngày hôm sau',
        tomorrow_month_valid: 'Có hiệu lực từ tháng sau',

        detail: {
            cell_flow: 'Dữ liệu',
            cell_period: 'Hiệu lực',
            buy_quantity: 'Số lượng',
            use_area: 'Bảo hiểm',
            use_intro: 'Điều khoản và Điều kiện',
            buy_btn: 'Đặt hàng',
            pay: 'Thanh toán',
            buy_tips: 'Bạn đang sử dụng gói %@packageName. Bạn có muốn mua gói này không?',
            haveOrderTips: "Đã tạo đơn hàng chờ thanh toán. Nhấn Xác nhận để đến Trang Dữ liệu của tôi！"
        },

        confirm: {
            title: 'Xác nhận đơn hàng',
            real_pay_amount: 'Số tiền đã trả',
            online_payment: 'Thanh toán trực tuyến',
            create_order_error: 'Thiết lập không thành công'
        }
    },
    pay: {
        result: {
            loading_order_status: 'Đang tải trạng thái đơn hàng…',
            buy_success: 'Đơn hàng hoàn tất',
            buy_pending: 'Đang chờ xác nhận',
            buy_pending_tip: 'Đang xử lý thanh toán…Nếu thanh toán không được chuyển trong vòng 10 phút, vui lòng liên hệ với chúng tôi để được hỗ trợ.',
            get_payment_info_fail: 'Việc thu thập thông tin thanh toán không thành công',
            cell_package: 'Bưu kiện',
            cell_buy_amount: 'Tổng phụ',
            cell_real_amount: 'Số tiền đã trả',
            go_to_order_btn: 'Đi tới Gói của tôi',
            back_home: 'Quay lại trang chủ',
            back_mall: 'Quay lại trung tâm mua sắm',
            ordersn_empty: 'SN đơn hàng không được để trống',
            order_search_error: 'Lỗi không mong muốn',
            goodsName: 'Tên sản phẩm'
        },
        fail: {
            payment_fail: 'Thanh toán không thành công',
            back_home: 'Quay lại trang chủ'
        }
    },
    CountryGroup: {
        title: "Quốc gia/khu vực",
        placeholder: "Tìm kiếm quốc gia hoặc khu vực",
        clear: "Thông thoáng",
        history: "Lịch sử tìm kiếm"
    },
    PromotionCode: {
        verification: {
            title: 'Mã phiếu thưởng',
            minititle: 'Mã phiếu thưởng',
            input: 'Vui lòng nhập mã nạp tiền',
            explain: 'Mẹo: Chạm vào nút quét ở trên cùng bên phải để quét mã QR của thẻ voucher hoặc nhập thủ công mã voucher (phân biệt chữ hoa chữ thường) nếu không hoạt động.',
            submit: 'Nộp',
            exchange: 'Chuộc lại',
            cancel: 'Hủy bỏ',
            Inquiry: "Bạn có chắc chắn để trao đổi",
            ErrorCode: 'Lỗi mã nạp tiền'
        },
        recharge_success: {
            package: 'Bưu kiện',
            content: 'Đã đổi thành công',
            back: 'Quay lại Trung tâm mua sắm',
            view_packets: 'Đi tới Gói của tôi'
        }
    },
    order: {
        state: {
            inUse: 'Đã kích hoạt',
            isFirst: 'Được ưu tiên',
            toFirst: 'Đặt mức độ ưu tiên',
            inactive: 'Chưa kích hoạt'
        },
        periodUnits: {
            minute: 'phút)',
            hour: 'giờ)',
            day: '(các) ngày',
            month: 'tháng'
        },
        useIntro: {
            tip1: 'Gói data không giới hạn có mức độ ưu tiên cao hơn gói data dung lượng lớn.',
            tip2: 'Ưu tiên sử dụng sẽ dựa trên ngày mua của cùng loại gói, tức là gói có ngày mua sớm nhất sẽ được sử dụng hết trước, trong khi đó ưu tiên của gói đơn khu vực sẽ cao hơn gói khu vực.',
            tip3: 'Bạn cũng có thể tự điều chỉnh mức độ ưu tiên sử dụng các gói cùng loại.'
        },
        myFlow: 'Dữ liệu của tôi',
        remainingFlow: 'Dữ liệu còn lại',
        remainingTime: 'hợp lệ trái',
        remainingHighFlow: 'Dữ liệu tốc độ cao còn lại',
        validPeriod: 'hiệu lực',
        noneFlow: 'Không có gói dữ liệu',
        noneFlowTip: 'Hãy mua gói data và tận hưởng mạng chất lượng cao',
        buyPackFlow: 'Mua gói',
        checkInvalidFlow: 'Kiểm tra gói data hết hạn',
        orderList:{
            "title": "đơn đặt hàng của tôi",
            "amount_paid": "Tổng cộng",
            "device": "Thiết bị sở hữu",
            "order_details": "Chi tiết đặt hàng",
            "total_amont": "Tổng phụ",
            "orderSN": "Đặt hàng số.",
            "createTime": "Thời gian sáng tạo",
            "cancelTime": "Giờ đóng cửa",
            "payTime": "Thời gian đặt hàng",
            "unsubTime": "Thời gian bị hủy",
            "payMethod": "Phương thức thanh toán",
            "thirdSN": "Số giao dịch",
            "delete": "Xóa bỏ",
            "cancel": "Hủy đơn hàng",
            "unsub": "Đền bù",
            "goto_cancel": "Bạn có muốn hủy đơn hàng không?",
            "goto_unsubscribe": "Bạn có muốn hủy đăng ký đơn hàng?",
            "delete_Tips": "Đơn hàng không thể được tiếp tục lại sau khi bị xóa, do đó các vấn đề sau dịch vụ của bạn không thể được xử lý.Bạn có chắc chắn xóa nó không?",
            "status_success": "Hoàn thành",
            "status_pending": "Chưa thanh toán",
            "status_cancel": "Đã đóng",
            "status_unsub": "Đã hủy",
            "payMethod_stripe": "Thẻ tín dụng"
          },
    },
    registerlogin: { 
        create_account_tip:"Tạo một tài khoản, bắt đầu trải nghiệm độc quyền",
        select_country_tip:"Thiết bị sử dụng quốc gia/khu vực",
        email_name: "Thư",
        phone_name: "Điện thoại",
        email_address: "Địa chỉ email",
        password: "mật khẩu",
        country: "quốc gia",
        select_country: "Chọn một quốc gia",
        cancel: "Hủy bỏ",
        confirm: "Chắc chắn",
        please_enter: "Vui lòng nhập 6-20 ký tự (kết hợp các chữ cái, số hoặc ký hiệu)",
        select_country_tips: "Lựa chọn quốc gia là để xem các gói địa phương. Nó không thể được thay đổi sau khi đăng ký. Vui lòng xác nhận!",
        global_roaming: "Mã miền quốc tế",
        phone_number: "Số điện thoại",
        agree: "đồng ý",
        user_agreement: "Thỏa thuận người dùng",
        and: "Và",
        privacy_policy: "Chính sách bảo mật",
        register_login: "Đăng ký hoặc đăng nhập",
        login_error: "Số lượng đăng nhập quá thường xuyên, vui lòng thử lại sau!",
        register_error: "Số lượng đăng ký quá thường xuyên, vui lòng thử lại sau!",
        forgot_pwd: "Quên mật khẩu",
        app_tips: "Đăng nhập vào ứng dụng với tài khoản này sau khi tải xuống để truy cập nhiều tính năng hơn.",
        download_app: "Đi tải xuống ứng dụng",
        rememberPwd: "Hãy nhớ mật khẩu",
        third_login: "Tiếp tục với",
        agreement_tips: "Vui lòng chọn hộp Thỏa thuận người dùng và Chính sách quyền riêng tư",
        selectCountry_tips: "Xin vui lòng lưu ý rằng quốc gia đã đăng ký sẽ ảnh hưởng trực tiếp đến các phương thức thanh toán và loại tiền tệ sau, vui lòng chọn theo nhu cầu của bạn.",
        login_error_cancel: "Người dùng đã hủy đăng nhập",
        login_error_auth: "Vui lòng cho phép pop-up từ cài đặt trình duyệt",
        device_tips: "Thiết bị chờ kích hoạt. Xử lý trong 24 giờ."
      },
      forgotPwd: {
        forgot_pwd: "Quên mật khẩu",
        email_address: "Địa chỉ email",
        next: "Kế tiếp",
        email_has_been_sent: "Chúng tôi đã gửi email đến %@email. Vui lòng nhấp vào liên kết và làm theo các bước để lấy mật khẩu của bạn.",
        have_retrieved_it: "Tôi đã tìm thấy nó",
        unable_to_receive_email: "Không thể nhận được email? Vui lòng kiểm tra xem có email từ %@email dưới thư mục thư rác của bạn và thư mục thư bị xóa không",
        or: "hoặc",
        resend: "Chia rẽ",
        global_roaming: "Mã miền quốc tế",
        phone_number: "Số điện thoại",
        verification_code_has_been_sent: "Chúng tôi đã gửi mã xác minh đến:",
        verification_code: "Mã xác minh",
        no_verification_code_received: "Không nhận được mã xác minh?",
        please_enter: "Vui lòng nhập 6-20 ký tự (kết hợp các chữ cái, số hoặc ký hiệu)",
        reset_password: "Đặt lại mật khẩu",
        reset_successful: "Đặt lại thành công"
      },
      coupons: {
        coupons_name: "Phiếu giảm giá",
        no_coupons: "Chưa có phiếu giảm giá",
        no_data: "Chưa có dữ liệu",
        applicable_to_the_following: "Phiếu giảm giá phù hợp cho gói dữ liệu sau đây"
      },
      digital: {
        title: "Thiết bị Sn",
        purchased: "Mua hàng của tôi",
        viewAll: "Hơn",
        skinStore: "Cửa hàng sản phẩm",
        completed: "Đã mua",
        goBuy: "Mua",
        order: {
            title: "Đơn đặt hàng đã mua"
        },
        detail: {
            describe: "Sự miêu tả"
        }
    },
    viewPL: {
        other: 'khác'
      },
    invalidFlow: {
        stateName: "Trạng thái",
        state: {
            NOT_ACTIVATED: "Bất hoạt",
            IN_USING: "Có sẵn",
            USE_END: "Kiệt sức",
            EXPIRE: "Hết hạn",
            TRANSFER: "Chuyển khoản",
            UNSUBSCRIBE: "Hủy bỏ",
            VALID: "Có hiệu lực",
            INVALID: "Không hợp lệ",
            EXCHANGE_POINTS: "Đổi điểm"
        },
        noneFlow: "Không có gói dữ liệu hết hạn",
        pageName: "Gói dữ liệu hết hạn"
    },
    flowDetail: {
        title: "Chi tiết dữ liệu",
        flow: "dữ liệu",
        validTime: "Chi tiết dữ liệu",
        invalidTime: "Có hiệu lực cho đến khi",
        coverage: "Bảo hiểm",
        useIntro: "Điều khoản và Điều kiện",
        purchaseTime: "Đã mua tại",
        subtotal: "Tổng phụ",
        status: "Trạng thái",
        cancel: "Hủy bỏ",
        buyAgain: "Mua lại lần nữa",
        validity: "hiệu lực",
        tip: "Để ý",
        cancelTip: "Bạn có chắc chắn muốn hoàn lại gói này không?",
        dataLeft: "Dữ liệu còn lại"
    },
    netError: {
        try_again: "Thử lại",
        net_error: "Không có mạng",
        try_again_desc: "Vui lòng kiểm tra cài đặt mạng và thử lại"
    },
    loadFail: {
        try_again: "Thử lại",
        load_fail: "Tải không thành công",
        load_fail_desc: "Tải dữ liệu không thành công, vui lòng thử lại",
        IMEI_Not_Exist: "IMEI không tồn tại, vui lòng thử nhập từ lối vào bên phải",
        Project_Not_Exist: "Đã xảy ra lỗi. Vui lòng liên hệ bộ phận chăm sóc khách hàng.(01)",
        commonError: "Đã xảy ra lỗi. Vui lòng liên hệ với dịch vụ khách hàng."
    },
    settlement_Easy_and_convenient: "Dễ dàng và thuận tiện",
    settlement_Great_deal: "Thỏa thuận tuyệt vời",
    settlement_Safe_and_secure: "An toàn và an toàn",
    settlement_Autopay_service_regulation: "Quy định dịch vụ tự động",
    settlement_Read: "Đọc",
    settlement_No_coupon: "Không có phiếu giảm giá có sẵn",
    settlement_Subtotal: "Tổng phụ",
    settlement_Coupon: "Phiếu giảm giá",
    settlement_TOTAL: "Tổng cộng",
    settlement_promotion_tip: "Ưu đãi quảng cáo không thể được sử dụng cùng với bất kỳ phiếu giảm giá nào",
    settlement_coupon_tip: "Phiếu giảm giá không thể được sử dụng cùng với bất kỳ ưu đãi quảng cáo nào khác",
    member_myFlow_noList: "Không có dữ liệu",
    detail_se_content: "Một cách an toàn, dễ dàng và thuận tiện. Bạn có thể hủy đăng ký bất cứ lúc nào",
    Enter_Promo_code: "Mã khuyến mại",
    Enter_Promo_Coupon:"Phiếu giảm giá",
    settlement_Not_used_coupon:"phiếu giảm giá không được sử dụng",
    settlement_Available_coupon:"Có sẵn",
    settlement_Unavailable_coupon:"Không có sẵn",
    please_Enter_Promo_code: "Vui lòng nhập mã khuyến mãi",
    please_Select_Coupon_use:　"Vui lòng chọn phiếu giảm giá bạn muốn sử dụng.",
    Buy_Now: "Mua ngay",
    Dont_Use_Any: "Không sử dụng bất kỳ",
    settlement_confirm:"Xác nhận",
    flowDetail_unsubscribe: "Hủy đăng ký",
    flowDetail_unsubscribed: "Không được đăng ký",
    flowDetail_isCancelPackage: "Hủy đăng ký gói này?",
    flowDetail_confirmAgreementUnsubscribe: "Bạn không thể có thỏa thuận tuyệt vời sau khi hủy đăng ký. Bạn có chắc là bạn muốn hủy đăng ký?",
    flowDetail_cancel: "Hủy bỏ",
    flowDetail_cancelSuccess: "Hủy đăng ký thành công",
    packages_detail_promotion: "Khuyến mãi",
    orderTips: {
        "iDay": "ngày",
        "iDays": "ngày",
        "iMonth": "tháng",
        "iMonths": "tháng",
        'First_charge_discount': "<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol trên lần mua đầu tiên của bạn, Trả tiền %@money/%@periodSymbol sau, Bạn có thể hủy đăng ký bất cứ lúc nào",
        'Monthly_discount': "Lưu %@saveMoney mỗi %@period! Bạn có thể hủy đăng ký bất cứ lúc nào ",
        'Ordinary_monthly_package': "Một cách an toàn, dễ dàng và thuận tiện. Bạn có thể hủy đăng ký bất cứ lúc nào",
        "AlreadyPurchased": 'Xin lỗi vì bạn chỉ có thể đăng ký một gói dữ liệu tại thời điểm này. Vui lòng hủy đăng ký khỏi nhóm “%@” và đăng ký sau cho bất kỳ gói nào bạn mong muốn sau khi hết hạn.',
        "Contract_recommendation_First": '<label>Với dịch vụ Autopay, trong lần mua đầu tiên của bạn, chỉ trả tiền</label>'
            + '<p class="money">%@firstMoney</p>'
            + '<p class="SubscribeTips">Bạn có thể hủy đăng ký bất cứ lúc nào'
            + '<a class="btn">Đặt mua ></a></p>',
        "Contract_recommendation_Monthly_discount": "<label>Với dịch vụ tự động, chỉ thanh toán</label>"
            + '<p class="money">%@money</p>'
            + '<p class="SubscribeTips">Bạn có thể hủy đăng ký bất cứ lúc nào'
            + '<a class="btn">Đặt mua ></a></p>',
        "Contract_recommendation_General": "<label>Với dịch vụ tự động</label>"
            + '<p class="money">%@money</p>'
            + '<p class="SubscribeTips">Một cách an toàn, dễ dàng và thuận tiện. Bạn có thể hủy đăng ký bất cứ lúc nào'
            + '<a href="javascript:;" class="btn">Đặt mua ></a></p>',
        'BanlanceDoubleCheck': 'Bạn có chắc là bạn muốn thanh toán với số dư?',
    },
    feedback: {
        title: "nhận xét",
        placeholder: "Vui lòng vào quốc gia bạn muốn ghé thăm hoặc bất kỳ câu hỏi nào khác, và chúng tôi sẽ đáp ứng nhu cầu của bạn càng sớm càng tốt!",
        submit: "Gửi đi",
        submit_success: "Gửi thành công",
        other_opinions: "Ý kiến khác"
    },
    view_country_input: 'Vui lòng nhập tài khoản của bạn',
    select_package: {
        title: "Chọn Dữ liệu",
        allPackage: 'Tất cả Dữ liệu',
        type: "Loại",
        flow: "Dữ liệu",
        month_package: "Gói Tháng",
        flow_package: "Gói Dữ Liệu",
        time: "Thời lượng",
        period: "Chu kỳ",
        auto_debit: "Thông tin Tự động trừ tiền",
        auto_subscribe: "Tự Động Gia Hạn",
        detail: "Chi tiết Dữ liệu",
        carrier: "Các Nhà cung cấp được Hỗ trợ",
        country: "Quốc Gia Được Bao Phủ",
        notice: "Hướng Dẫn Mua Hàng"
    }
}